<template>
  <div class="box text-gray-50">
    <div class="box-heading">
      <div class="text-13">友情链接</div>
    </div>
    <ul class="plan-list text-13">
      <template v-for="item in nodes">
        <li class="py-1 cursor-pointer">
          <a :href="item.link_url" target="_blank">{{ item.link_name }}</a>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'HotTags',
  data () {
    return {
      nodes: []
    }
  },
  methods: {
    loadNodes () {
      this.$http
        .get('friendlinks')
        .then(nodes => (this.nodes = nodes.data));
    }
  },
  created () {
    this.loadNodes()
  }
}
</script>

<style scoped>
</style>
